import React from "react";
import "./ErrorPage.css";
import { Box } from "@mui/material";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import img404 from "../asset/404error.png";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
const Error404Page = () => {
  return (
    
    <>
     <div style={{ height: "100%", margin: "0", padding:"0"}}>
    <div style={{display: "flex",flexDirection: "column", minHeight: "100vh", width: "100%"}}>
      <Header isVisible={true} buttonsVisible={true} />
      <div style={{flex: "1"}}>
      <Box>
        <div className="headtext">
          <div className="headimg">
            <img src={img404} alt="404 Error page"/>
             <div className="textonimg">
            <h2 id="shadow">
              Oops!! &nbsp;The page you are looking for cannot be f
              <BlockOutlinedIcon id="block" />
              und. &nbsp;{" "}
            </h2>
          </div>
          </div>

         
        </div>
      </Box>
      </div>
      <div style={{ position:"relative", bottom:"0"}}>
      <Footer />
      </div>
    </div>
    </div>
    </>
  );
};

export default Error404Page;
